import React, { ChangeEvent, useState } from 'react';
import { Camera, InsertDriveFile } from '@mui/icons-material';
import CameraInput, { FACING_MODES } from 'react-html5-camera-photo';
import { Dialog, IconButton, List, ListItem, Popover } from '@mui/material';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import './AttachmentMenu.scss';

export type AttachmentMenuProps = {
  anchorEl: any;
  onClose: () => void;
  onImageCapture: (data: string) => void;
  onFileUpload: (file: File) => void;
};

export const AttachmentMenu: React.FC<AttachmentMenuProps> = ({
  anchorEl,
  onClose,
  onImageCapture,
  onFileUpload,
}) => {
  const { t } = useTranslation();
  const [showCamera, setShowCamera] = useState(false);

  const handleTakePhoto = async (data: string) => {
    setShowCamera(false);
    onImageCapture(data);
    onClose();
  };
  const handleCameraError = () => {
    toast.error('You need to give permission to capture when asked');
    setShowCamera(false);
    onClose();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const fileSize = file.size / 1024 ** 2;

      if (fileSize <= 5) {
        onFileUpload(file);
      } else {
        toast.error(t('error_file_size_exceeded'));
      }
    }

    onClose();
  };

  const handleCloseModal = () => setShowCamera(false);

  return (
    <>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={onClose}
      >
        <List>
          <ListItem>
            <IconButton
              title="Take Picture"
              onClick={() => setShowCamera(true)}
            >
              <Camera />
            </IconButton>
          </ListItem>
          <ListItem>
            <IconButton title={t('label_upload_document')} component="label">
              <InsertDriveFile />
              <input
                hidden
                accept="image/*, application/*"
                multiple
                type="file"
                onChange={handleChange}
              />
            </IconButton>
          </ListItem>
        </List>
      </Popover>
      <Dialog
        className="take-photo-modal"
        open={showCamera}
        onClose={handleCloseModal}
      >
        <CameraInput
          imageType="png"
          sizeFactor={0.5}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          isImageMirror={false}
          isDisplayStartCameraError={false}
          onTakePhoto={handleTakePhoto}
          onCameraError={handleCameraError}
        />
      </Dialog>
    </>
  );
};
